'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var cancel = require('./cancel-2161b174.js');
var hexToRgb = require('./hexToRgb-7c8edffc.js');

var pillVariantsStyles = {
    default: styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n    background-color: ", ";\n  "], ["\n    color: ", ";\n    background-color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.universal.white;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.secondary;
    }),
    secondary: styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n    background-color: ", ";\n    font-size: 14px;\n    line-height: 22px;\n    font-weight: normal;\n    padding: 5px 36px 5px 14px;\n    margin-right: 8px;\n  "], ["\n    color: ", ";\n    background-color: ", ";\n    font-size: 14px;\n    line-height: 22px;\n    font-weight: normal;\n    padding: 5px 36px 5px 14px;\n    margin-right: 8px;\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyDark;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyLight;
    }),
    inline: styled.css(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n    background-color: ", ";\n    font-size: 14px;\n    line-height: 22px;\n    font-weight: normal;\n    padding: 4px 8px;\n    margin-right: 4px;\n  "], ["\n    color: ", ";\n    background-color: ", ";\n    font-size: 14px;\n    line-height: 22px;\n    font-weight: normal;\n    padding: 4px 8px;\n    margin-right: 4px;\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyDark;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyLight;
    }),
    active: styled.css(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n    background-color: ", ";\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 22px;\n    padding: 2px 8px;\n    &:hover {\n      background-color: ", " !important;\n    }\n  "], ["\n    color: ", ";\n    background-color: ", ";\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 22px;\n    padding: 2px 8px;\n    &:hover {\n      background-color: ", " !important;\n    }\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.admin.green;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.admin.greenLight;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.admin.greenLight;
    }),
    warning: styled.css(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n    background-color: ", ";\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 22px;\n    padding: 2px 8px;\n    &:hover {\n      background-color: ", " !important;\n    }\n  "], ["\n    color: ", ";\n    background-color: ", ";\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 22px;\n    padding: 2px 8px;\n    &:hover {\n      background-color: ", " !important;\n    }\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.admin.orange;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.admin.lightOrange;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.admin.lightOrange;
    }),
    inactive: styled.css(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n    background-color: ", ";\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 22px;\n    padding: 2px 8px;\n    &:hover {\n      background-color: ", " !important;\n    }\n  "], ["\n    color: ", ";\n    background-color: ", ";\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 22px;\n    padding: 2px 8px;\n    &:hover {\n      background-color: ", " !important;\n    }\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyDark;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyMedium;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyMedium;
    }),
};
var Container = styled__default.div(templateObject_7 || (templateObject_7 = tslib_es6.__makeTemplateObject(["\n  position: relative;\n  display: inline-block;\n  border-radius: 16px;\n  font-family: ", ";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 10px;\n  line-height: 16px;\n  padding: ", ";\n  ", ";\n  ", "\n  ", "\n\n  &:hover {\n    background-color:\n      ", ";\n\n    .cancel-icon {\n      color: ", ";\n    }\n  }\n"], ["\n  position: relative;\n  display: inline-block;\n  border-radius: 16px;\n  font-family: ", ";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 10px;\n  line-height: 16px;\n  padding: ", ";\n  ", ";\n  ",
    "\n  ", "\n\n  &:hover {\n    background-color:\n      ", ";\n\n    .cancel-icon {\n      color: ", ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var readOnly = _a.readOnly;
    return (readOnly ? '0px' : '2px 8px');
}, function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'default' : _b, readOnly = _a.readOnly;
    return (readOnly ? pillVariantsStyles.inline : pillVariantsStyles[variant]);
}, function (_a) {
    var _b;
    var color = _a.color;
    return (color && "\n    color: " + color + ";\n    background-color: rgba(" + ((_b = hexToRgb.hexToRgb(color)) === null || _b === void 0 ? void 0 : _b.join(',')) + ", .1);\n  ");
}, function (_a) {
    var _b = _a.isDeleted, isDeleted = _b === void 0 ? false : _b;
    return isDeleted && 'opacity: 0.5;';
}, function (_a) {
    var theme = _a.theme, readOnly = _a.readOnly;
    return (readOnly ? theme.colors.greys.adminGreyLight : theme.colors.greys.adminGreyMedium);
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
});
var Icon = styled__default(cancel.Cancel)(templateObject_8 || (templateObject_8 = tslib_es6.__makeTemplateObject(["\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  height: 20px;\n  width: 20px;\n  cursor: ", ";\n"], ["\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  height: 20px;\n  width: 20px;\n  cursor: ", ";\n"])), function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
});
var Pill = function (_a) {
    var children = _a.children, _b = _a.variant, variant = _b === void 0 ? 'default' : _b, _c = _a.icon, icon = _c === void 0 ? false : _c, onClick = _a.onClick, _d = _a.dataTestId, dataTestId = _d === void 0 ? 'pill' : _d, _e = _a.dataCy, dataCy = _e === void 0 ? 'pill' : _e, _f = _a.disabled, disabled = _f === void 0 ? false : _f, _g = _a.isDeleted, isDeleted = _g === void 0 ? false : _g, _h = _a.readOnly, readOnly = _h === void 0 ? false : _h, rest = tslib_es6.__rest(_a, ["children", "variant", "icon", "onClick", "dataTestId", "dataCy", "disabled", "isDeleted", "readOnly"]);
    var handleOnKeyDownCancel = React.useCallback(function (event) {
        event.stopPropagation();
        if (onClick && (event.key === 'Enter' || event.key === ' ')) {
            onClick(event);
        }
    }, [onClick]);
    return (React__default.createElement(Container, tslib_es6.__assign({ isDeleted: isDeleted, variant: variant, "data-testid": dataTestId, "data-cy": dataCy, readOnly: readOnly }, rest),
        children,
        !readOnly && icon && (React__default.createElement(Icon, { tabIndex: 0, variant: "adminGreyMediumAlt", onClick: onClick, dataTestId: "pill-icon", className: "cancel-icon", disabled: disabled, onKeyDown: handleOnKeyDownCancel }))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;

exports.Pill = Pill;
